let prices = {
  frame: 0,
  passe: 0,
  glass: 0,
};

//Global variables
let no_frame_variants = true,
  no_passe_variants = true,
  no_glass_variants = true,
  no_passe_selected = true,
  no_glass_selected = true,
  glass_deleted = false,
  replace_inputs = false,
  first_access = false,
  default_color_selected = false,
  previous_color = '',
  portrait_width_changed = false,
  convert_to_pixels = 420,
  portrait_width = 0,
  picture_width = 0,
  picture_height = 0,
  picture_actual_width = 0,
  picture_actual_height = 0,
  frameWidth = 0,
  frame_actual_width = 0,
  frame_actual_height = 0,
  frame_price = 0,
  passe_price = 0,
  glass_price = 0,
  frame_default_price = 0,
  passe_default_price = 0,
  glass_default_price = 0,
  product_price = $('.product-price').data('product-price'),
  framing_cost_price = $('.framing-cost-price').data('product-price'),
  selected_frame_name = 'default';

// Variables needed for the configurator SKU
let sku_full = '';
let sku_frame = 'NA';
let sku_frame_height = '';
let sku_frame_width = '';
let sku_frame_colour = '';
let sku_glass = 'X';
let sku_passe_full = '';
let sku_picture_width = '';
let sku_picture_height = '';
let sku_passe_colour = '';
let tempPasseHeight = '';
let tempPasseWidth = '';

// Hidden property inputs
const sku_input_frame = document.querySelector('input[name="properties[custom_frame_sku]"]');
const sku_input_passe = document.querySelector('input[name="properties[custom_passe_sku]');
const frameSizeInput = document.querySelector('input[name="properties[_Frame size]"]');

//Default buttons (clicked on page load)
const default_passe_btn = $('.default-passe'),
  default_glass_btn = $('.default-glass');

//Translations for disabled button
const disabled_add_to_cart = $('.add-to-cart--disabled'),
  no_passe_selected_translation = $('[name=no-passe-selected]').val(),
  no_glass_selected_translation = $('[name=no-glass-selected]').val(),
  no_frames_available_translation = $('[name=no-frames-available]').val(),
  no_passe_available_translation = $('[name=no-passe-available]').val(),
  no_glass_available_translation = $('[name=no-glass-available]').val(),
  dimensions_inside_translation = $('[name=frame-inside]').val(),
  add_to_cart_form = '.configurator-form';

//drawer variables
let frame_material = 'default',
  frame_profile_width = '0',
  frame_profile_height = '0';

//--- FUNCTIONS USED IN CONFIGURATOR --//
//Round up selected number to closest number that is divisible with 5
const roundUpTo = function (number, round_with) {
  return Math.ceil(number / round_with) * 10;
};

//Add line item with id to form
const addLineItem = function (
  line_item_id,
  properties_translation,
  value,
  form
) {
  //First clear the line item if we have it added
  $(`#${line_item_id}`).remove();
  //Form line item attribute with ID, translation and value
  const line_item = `<input type="hidden" id="${line_item_id}" name="properties[${properties_translation}]" value="${value}"/>`;
  //Add line item to the form
  $(form).append(line_item);
};

//Function for finding the right variant and adding it to the form if we have the variant available
const variantCheck = function (
  findByKeyValue,
  picture_width,
  picture_height,
  input_class,
  option_type,
  default_price
) {
  //First find the variant with width and height then find variant with height and width
  const variantWH = findByKeyValue(
    'title',
    `${picture_width.toString()}x${picture_height.toString()}`
  );
  const variantHW = findByKeyValue(
    'title',
    `${picture_height.toString()}x${picture_width.toString()}`
  );

  //Adding the right variants to cart and if no variants are found, don't let customer to buy it
  if (variantWH !== undefined) {
    //add input field for cart with right variant id
    const input_field = `<input type="hidden" name="id[]" class="${input_class}" value="${variantWH.id}">`;

    $(`.${input_class}`).remove();
    $('.configurator-form').append(input_field);
    if (option_type == 'frame') {
      no_frame_variants = false;
      frame_price = variantWH.price;
      // $('.configurator-form').append(frame_sku_input);
    } else if (option_type == 'passe') {
      no_passe_variants = false;
      passe_price = variantWH.price;
      let frameDimesions = picture_actual_width + 'cm X ' + picture_actual_height + 'cm';
      frameSizeInput.value = frameDimesions;
    } else {
      no_glass_variants = false;
      glass_price = variantWH.price;
    }
  } else if (variantHW !== undefined) {
    //If frame doesn't have right variant with width/height add variant with height/width to reduce needed variants
    const input_field = `<input type="hidden" name="id[]" class="${input_class}" value="${variantHW.id}">`;

    $(`.${input_class}`).remove();
    $('.configurator-form').append(input_field);
    if (option_type == 'frame') {
      no_frame_variants = false;
      frame_price = variantHW.price;
      // $('.configurator-form').append(frame_sku_input);
    } else if (option_type == 'passe') {
      no_passe_variants = false;
      passe_price = variantHW.price;
      // $('.configurator-form').append(passe_sku_input);
    } else {
      no_glass_variants = false;
      glass_price = variantHW.price;
    }
  } else {
    //If no right variants, delete the input field and disable add to cart button with right text
    $(`.${input_class}`).remove();
    if (option_type == 'frame') {
      no_frame_variants = true;
      frame_price = default_price;
    } else if (option_type == 'passe') {
      no_passe_variants = true;
      passe_price = default_price;
    } else {
      no_glass_variants = true;
      glass_deleted = true;
      glass_price = default_price;
    }
  }
};

//Change text of an element with jquery class
const changeText = function (item_class, content) {
  item_class.text(content);
};

//Hide element
const hideElement = function (item_class) {
  item_class.css('display', 'none');
};

//Show element
const showElementFlex = function (item_class) {
  item_class.css('display', 'flex');
};

//Click element by class
const clickByClass = function (item_class) {
  item_class.trigger('click');
};

//Debounce function
const debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

//Check input field min and max values
const minmax = function (value, min, max) {
  if (parseInt(value) < min || isNaN(parseInt(value))) return min;
  else if (parseInt(value) > max) return max;
  else return value;
};

//Option clicked functions
function option_clicked(evt) {
  const $option = $(this);
  evt.preventDefault();

  let option = {
    type: $option.data('type'),
    handle: $option.data('handle'),
    price: $option.data('price'),
    id: $option.data('id'),
    cm_compare: $option.data('cm-divider'),
    frame_width: $option.data('frame-width'),
    frame_corner_src: $option.data('frame-corner-src'),
    frame_lr_src: $option.data('frame-lr-side-src'),
    frame_tb_src: $option.data('frame-tb-side-src'),
    frame_color_name: $option.data('frame-color-name'),
    frame_color_sku: $option.data('frame-color-sku'),
    frame_name: $option.data('frame-name'),
    frame_sku: $option.data('frame-sku'),
    passe_padding: $option.data('passe-padding'),
    passe_color: $option.data('passe-color'),
    passe_color_name: $option.data('passe-color-name'),
    passe_color_sku: $option.data('passe-color-sku'),
    width: $option.data('width'),
    height: $option.data('height'),
    frame_color_translation: $option.data('frame-color-translation'),
    passe_color_translation: $option.data('passe-color-translation'),
    actual_size_translation: $option.data('actual-width-translation'),
    product_data: [],
  };

    const element = document.getElementsByClassName('configurator-container');
    const topPos = element[0].getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: topPos, // scroll so that the element is at the top of the view
      behavior: 'smooth', // smooth scroll
    });

  if (parseFloat(option.width) > 80 || parseFloat(option.height) > 80) {
    const addToCart = document.querySelector('.btn_cart');
    const addToCartDisabled = document.querySelector('.add-to-cart-framemax');

    if (parseFloat(option.width) == 100 && parseFloat(option.height) > 80) {
      addToCart.style.display = "none";
      addToCartDisabled.style.display = "block";
    } else if (parseFloat(option.height) == 100 && parseFloat(option.width) > 80) {
      addToCart.style.display = "none";
      addToCartDisabled.style.display = "block";
    } else {
      addToCart.style.display = "block";
      addToCartDisabled.style.display = "none";
    }
  } else {
    const addToCart = document.querySelector('.btn_cart');
    const addToCartDisabled = document.querySelector('.add-to-cart-framemax');
    addToCart.style.display = "block";
    addToCartDisabled.style.display = "none";
  }

  if (parseFloat(option.width) > 80 && parseFloat(option.height) > 80) {
    const addToCart = document.querySelector('.btn_cart');
    const addToCartDisabled = document.querySelector('.add-to-cart-framemax');
    addToCart.style.display = "none";
    addToCartDisabled.style.display = "block";
  }

  const timestamp = Date.now();
  const timestampProperty = document.querySelector('.timestamp_property');
  timestampProperty.value = timestamp;

  let drawer_option = {
    material: $option.data('frame-material'),
    profile_width: $option.data('profile-width'),
    profile_height: $option.data('profile-height'),
  };

  //Passe partout color selection
  if (option.type == 'passe-color') {
    $('.passe-padding').css('border-color', option.passe_color);
    $('.single-option[data-type="passe-color"]').removeClass('selected');
    $option.addClass('selected');
    default_color_selected = true;
    previous_color = option.passe_color;

    let skuFrameHeight;
    if (picture_actual_height.toString().includes('.')) {
      if (picture_actual_height >= 100) {
        skuFrameHeight = picture_actual_height.toString().replace('.', '');
      } else {
        skuFrameHeight = '0' + picture_actual_height.toString().replace('.', '');
      }
    } else {
      if (picture_actual_height >= 100) {
        skuFrameHeight = picture_actual_height.toString() + '0';
      } else {
        skuFrameHeight = '0' + picture_actual_height.toString() + '0';
      }
    }
    let skuFrameWidth;
    if (picture_actual_width.toString().includes('.')) {
      if (picture_actual_width >= 100) {
        skuFrameWidth = picture_actual_width.toString().replace('.', '');
      } else {
        skuFrameWidth = '0' + picture_actual_width.toString().replace('.', '');
      }
    } else {
      if (picture_actual_width >= 100) {
        skuFrameWidth = picture_actual_width.toString() + '0';
      } else {
        skuFrameWidth = '0' + picture_actual_width.toString() + '0';
      }
    }
    let skuPicHeight;
    let passeHeight = option.height;
    passeHeight = passeHeight || tempPasseHeight;

    if (passeHeight.toString().includes('.')) {
      if (passeHeight >= 100) {
        skuPicHeight = passeHeight.toString().replace('.', '');
      } else {
        skuPicHeight = '0' + passeHeight.toString().replace('.', '');
      }
    } else {
      if (passeHeight >= 100) {
        skuPicHeight = passeHeight.toString() + '0';
      } else {
        skuPicHeight = '0' + passeHeight.toString() + '0';
      }
    }
    let skuPicWidth;
    let passeWidth = option.width;

    if (passeWidth == undefined) {
      passeWidth = tempPasseWidth;
    }
    if (passeWidth.toString().includes('.')) {
      if (passeWidth >= 100) {
        skuPicWidth = passeWidth.toString().replace('.', '');
      } else {
        skuPicWidth = '0' + passeWidth.toString().replace('.', '');
      }
    } else {
      if (passeWidth >= 100) {
        skuPicWidth = passeWidth.toString() + '0';
      } else {
        skuPicWidth = '0' + passeWidth.toString() + '0';
      }
    }

    sku_passe_colour = option.passe_color_sku;
    sku_passe_full = "YDPP" + skuFrameWidth + skuFrameHeight + skuPicWidth + skuPicHeight + option.passe_color_sku + "101";

    // Note: cf-product == custom frame product, as in just at frame configured from the "Fotokanders op maat" nav
    const currentURL2 = window.location.href
    if (currentURL2.includes("cf-product")) {
      sku_input_passe.value = sku_passe_full;
    } else {
      sku_input_passe.value = '';
    };

    //Add selected passe color to line items
    addLineItem(
      'passe-color-input',
      passe_color_translation,
      option.passe_color_name,
      add_to_cart_form
    );
    return;
  }

  //Get the product data from clicked product
  $.getJSON(`/products/${option.handle}.js`, function (product_data) {
    //Populate DATA from the clicked product
    option.product_data = product_data;
    //Function for finding the right variant by width and height
    function findByKeyValue(key, value) {
      var product = product_data;
      return product.variants
        .filter(function (item) {
          if (item[key] === value) {
            return item;
          }
        })
        .shift();
    }

    $('.single-option[data-type="' + option.type + '"]').removeClass(
      'selected'
    );

    //Frame selection clicked
    if (option.type == 'frame') {
      const currentURL = window.location.href
      if (currentURL.includes("cf-product")) {
        frameHeightChanged();
        frameWidthChanged();
      } else {

      };
      $('.frame-description > .rte').html(option.product_data.description);
      $('.frame-description > .rte').removeClass('hide');
      $('.frame-description > .show-details').removeClass('hide');
      $('.color-selection').find('.options').addClass('hide');
      $('.color-selection')
        .find('.options[data-handle="' + option.handle + '"]')
        .removeClass('hide');

      //Change selcted frame text
      $('.selected-frame--js').text(option.frame_name);

      sku_frame = option.frame_sku;

      //General frame width
      frameWidth = option.frame_width;

      //Round up to nearest integer what can be divided with 10
      calc_picture_width = roundUpTo(option.width, 10);
      picture_width = calc_picture_width;

      //Round up to nearest integer what can be divided with 10
      calc_picture_height = roundUpTo(option.height, 10);
      picture_height = calc_picture_height;

      frame_product_data = product_data;
      selected_frame_name = option.frame_name;
      frame_material = drawer_option.material;
      frame_profile_width = drawer_option.profile_width;
      frame_profile_height = drawer_option.profile_height;
      frame_default_price = option.price;

      //Translations
      frame_color_translation = option.frame_color_translation;
      passe_color_translation = option.passe_color_translation;
      actual_size_translation = option.actual_size_translation;

      //Assign actual width and height for drawer details if width/height is 0
      if (picture_actual_width < option.width) {
        picture_actual_width = option.width;
      }
      if (picture_actual_height < option.height) {
        picture_actual_height = option.height;
      }

      //Click first color
      $(`.${option.handle}-first-color`).trigger('click');

      if (first_access === false) {
        //Click passe-partout with 0 padding
        if (default_passe_btn.length) {
          clickByClass(default_passe_btn);
        }
        //Click anti reflex glass
        if (default_glass_btn.length) {
          clickByClass(default_glass_btn);
        }
      }

      //Check if we have the right variant available for frame
      variantCheck(
        findByKeyValue,
        picture_width,
        picture_height,
        'frame-input',
        option.type,
        frame_default_price
      );

      //Calculate real width and height
      if (passe_amount){
        picture_actual_width = +option.width + +passe_amount;
        picture_actual_height = +option.height + +passe_amount;
      } else {
        picture_actual_width = +option.width;
        picture_actual_height = +option.height;
      }

      //Doing the calculation to round up the width and height
      const calculated_passe_width = roundUpTo(picture_actual_width, 10);
      const calculated_passe_height = roundUpTo(picture_actual_height, 10);

      //Calculating the frames actual width and height and substracting the overlap (-1 in the end is the overlap, as in 0,5cm from both sides)
      frame_actual_height = parseFloat(picture_actual_height) + parseFloat(frame_profile_width) * 2 / 10 - 1;
      frame_actual_width = parseFloat(picture_actual_width) + parseFloat(frame_profile_width) * 2 / 10 - 1;

      let skuHeight;
      if (parseFloat(picture_actual_height).toString().includes('.')) {
        skuHeight = parseFloat(picture_actual_height).toString().replace('.', '');
      } else {
        skuHeight = parseFloat(picture_actual_height).toString() + '0';
      }

      if (parseFloat(picture_actual_height) < 100) {
          skuHeight = '0' + skuHeight;
      }

      let skuWidth;
      if (parseFloat(picture_actual_width).toString().includes('.')) {
        skuWidth = parseFloat(picture_actual_width).toString().replace('.', '');
      } else {
        skuWidth = parseFloat(picture_actual_width).toString() + '0';
      }

      if (parseFloat(picture_actual_width) < 100) {
        skuWidth = '0' + skuWidth;
      }

      let fullSKU = 'YD' + sku_frame + skuWidth + skuHeight + sku_frame_colour + sku_glass + '10';

      sku_input_frame.value = fullSKU;
      sku_full = fullSKU;

    if (option.passe_padding > 0) {
      let skuFrameHeight;
      if (picture_actual_height.toString().includes('.')) {
        if (picture_actual_height >= 100) {
          skuFrameHeight = picture_actual_height.toString().replace('.', '');
        } else {
          skuFrameHeight = '0' + picture_actual_height.toString().replace('.', '');
        }
      } else {
        if (picture_actual_height >= 100) {
          skuFrameHeight = picture_actual_height.toString() + '0';
        } else {
          skuFrameHeight = '0' + picture_actual_height.toString() + '0';
        }
      }
      let skuFrameWidth;
      if (picture_actual_width.toString().includes('.')) {
        if (picture_actual_width >= 100) {
          skuFrameWidth = picture_actual_width.toString().replace('.', '');
        } else {
          skuFrameWidth = '0' + picture_actual_width.toString().replace('.', '');
        }
      } else {
        if (picture_actual_width >= 100) {
          skuFrameWidth = picture_actual_width.toString() + '0';
        } else {
          skuFrameWidth = '0' + picture_actual_width.toString() + '0';
        }
      }
      let skuPicHeight;
      let passeHeight = option.height;
      if (passeHeight.toString().includes('.')) {
        if (passeHeight >= 100) {
          skuPicHeight = passeHeight.toString().replace('.', '');
        } else {
          skuPicHeight = '0' + passeHeight.toString().replace('.', '');
        }
      } else {
        if (passeHeight >= 100) {
          skuPicHeight = passeHeight.toString() + '0';
        } else {
          skuPicHeight = '0' + passeHeight.toString() + '0';
        }
      }
      let skuPicWidth;
      let passeWidth = option.width;

      if (passeWidth.toString().includes('.')) {
        if (passeWidth >= 100) {
          skuPicWidth = passeWidth.toString().replace('.', '');
        } else {
          skuPicWidth = '0' + passeWidth.toString().replace('.', '');
        }
      } else {
        if (passeWidth >= 100) {
          skuPicWidth = passeWidth.toString() + '0';
        } else {
          skuPicWidth = '0' + passeWidth.toString() + '0';
        }
      }

      sku_passe_full = "YDPP" + skuFrameWidth + skuFrameHeight + skuPicWidth + skuPicHeight + sku_passe_colour + "101";
      sku_input_passe.value = sku_passe_full;
    }

      //set first access to true
      first_access = true;
    }
    //Frame color clicked
    else if (option.type == 'color') {
      //Dimension calculation
      var cmToPixel =
        Math.round((convert_to_pixels * 100.0) / option.cm_compare) / 100;
      var frameWidthCm = option.frame_width;
      var frameRealWidthCalc =
        Math.round(cmToPixel * 100.0 * frameWidthCm) / 100;
      const frameRealWidth = frameRealWidthCalc.toFixed(0);

      sku_frame_colour = option.frame_color_sku;

      //Frame color selected
      no_frame_selected = false;
      // append the correct frame color to the SKU
      let getSku = $('.custom_sku').val();
      let updatedSku = getSku.replace(/(..)X/, `${sku_frame_colour}X`);
      $('.custom_sku').val(updatedSku);

      //Add padding for frame width
      $('.frames').animate(
        {
          'padding-top': frameRealWidth + 'px',
          'padding-right': frameRealWidth + 'px',
          'padding-bottom': frameRealWidth + 'px',
          'padding-left': frameRealWidth + 'px',
        },
        'fast'
      );
      //Add frame images
      $('.frame-corner').css({
        background: `url(${option.frame_corner_src})`,
        width: frameRealWidth + 'px',
        height: frameRealWidth + 'px',
      });
      $('.frame-side-lr').css({
        background: `url(${option.frame_lr_src})`,
        width: frameRealWidth + 'px',
      });
      $('.frame-side-tb').css({
        background: `url(${option.frame_tb_src})`,
        height: frameRealWidth + 'px',
      });

      //Add line_item color to cart
      addLineItem(
        'frame-color-input',
        frame_color_translation,
        option.frame_color_name,
        add_to_cart_form
      );
    }

    //Passe-partout selection clicked
    else if (option.type == 'passe') {
      const frameProperty = document.querySelector('input[name="properties[Frame size]"]');
      //Dimension calculation and other variables
      var cmToPixel =
        Math.round((convert_to_pixels * 100.0) / option.cm_compare) / 100;
      var passe_cm = option.passe_padding;
      var passe_width = Math.floor(cmToPixel * 100 * passe_cm) / 100;
      no_passe_selected = false;
      passe_default_price = option.price;
      var passe_amount = option.passe_padding * 2;

      if (option.passe_padding > 0) {
        $('.passe-selection')
          .find('.options')
          .find('.passe-color__container')
          .removeClass('hide');
        $('.passe-selection').find('.passe-color__text').removeClass('hide');
        $('.configurator-left').animate(
          {
            'padding-top': 40 + 'px',
          },
          'fast'
        );

        sku_passe_full = '';
      } else {
        // Remember the frame size without passepartout
        const baseHeight = parseFloat(option.height);
        const baseWidth = parseFloat(option.width);
        const baseFrameString = `${baseWidth}cm X ${baseHeight}cm`;
        frameProperty && (frameProperty.value = baseFrameString);
        $('.passe-selection')
          .find('.options')
          .find('.passe-color__container')
          .addClass('hide');
        $('.passe-selection').find('.passe-color__text').addClass('hide');
        $('.configurator-left').animate(
          {
            'padding-top': 40 + 'px',
          },
          'fast'
        );
      }

      $('.passe-padding').css(
        {
          border: passe_width.toFixed(0) + 'px solid' + previous_color,
        },
        'fast'
      );
      $('.single-option[data-type="no-passe"]').removeClass('selected');

      //Calculate real width and height
      picture_actual_width = +option.width + +passe_amount;
      picture_actual_height = +option.height + +passe_amount;

      //Doing the calculation to round up the width and height
      const calculated_passe_width = roundUpTo(picture_actual_width, 10);
      const calculated_passe_height = roundUpTo(picture_actual_height, 10);

      //Calculating the frames actual width and height and substracting the overlap (-1 in the end is the overlap, as in 0,5cm from both sides)
      frame_actual_height = parseFloat(picture_actual_height) + parseFloat(frame_profile_width) * 2 / 10 - 1;
      frame_actual_width = parseFloat(picture_actual_width) + parseFloat(frame_profile_width) * 2 / 10 - 1;

      let skuHeight;
      if (parseFloat(picture_actual_height).toString().includes('.')) {
        skuHeight = parseFloat(picture_actual_height).toString().replace('.', '');
      } else {
        skuHeight = parseFloat(picture_actual_height).toString() + '0';
      }

      if (parseFloat(picture_actual_height) < 100) {
          skuHeight = '0' + skuHeight;
      }

      let skuWidth;
      if (parseFloat(picture_actual_width).toString().includes('.')) {
        skuWidth = parseFloat(picture_actual_width).toString().replace('.', '');
      } else {
        skuWidth = parseFloat(picture_actual_width).toString() + '0';
      }

      if (parseFloat(picture_actual_width) < 100) {
        skuWidth = '0' + skuWidth;
      }

      let fullSKU = 'YD' + sku_frame + skuWidth + skuHeight + sku_frame_colour + sku_glass + '10';

      sku_input_frame.value = fullSKU;
      sku_full = fullSKU;

      let skuFrameHeight;
      if (picture_actual_height.toString().includes('.')) {
        if (picture_actual_height >= 100) {
          skuFrameHeight = picture_actual_height.toString().replace('.', '');
        } else {
          skuFrameHeight = '0' + picture_actual_height.toString().replace('.', '');
        }
      } else {
        if (picture_actual_height >= 100) {
          skuFrameHeight = picture_actual_height.toString() + '0';
        } else {
          skuFrameHeight = '0' + picture_actual_height.toString() + '0';
        }
      }
      let skuFrameWidth;
      if (picture_actual_width.toString().includes('.')) {
        if (picture_actual_width >= 100) {
          skuFrameWidth = picture_actual_width.toString().replace('.', '');
        } else {
          skuFrameWidth = '0' + picture_actual_width.toString().replace('.', '');
        }
      } else {
        if (picture_actual_width >= 100) {
          skuFrameWidth = picture_actual_width.toString() + '0';
        } else {
          skuFrameWidth = '0' + picture_actual_width.toString() + '0';
        }
      }
      let skuPicHeight;
      let passeHeight = option.height;
      if (passeHeight.toString().includes('.')) {
        if (passeHeight >= 100) {
          skuPicHeight = passeHeight.toString().replace('.', '');
        } else {
          skuPicHeight = '0' + passeHeight.toString().replace('.', '');
        }
      } else {
        if (passeHeight >= 100) {
          skuPicHeight = passeHeight.toString() + '0';
        } else {
          skuPicHeight = '0' + passeHeight.toString() + '0';
        }
      }

      let skuPicWidth;
      tempPasseHeight = option.height;
      tempPasseWidth = option.width;
      let passeWidth = option.width;

      if (passeWidth.toString().includes('.')) {
        if (passeWidth >= 100) {
          skuPicWidth = passeWidth.toString().replace('.', '');
        } else {
          skuPicWidth = '0' + passeWidth.toString().replace('.', '');
        }
      } else {
        if (passeWidth >= 100) {
          skuPicWidth = passeWidth.toString() + '0';
        } else {
          skuPicWidth = '0' + passeWidth.toString() + '0';
        }
      }

      sku_passe_full = "YDPP" + skuFrameWidth + skuFrameHeight + skuPicWidth + skuPicHeight + sku_passe_colour + "101";
      sku_input_passe.value = sku_passe_full;

      if (option.passe_padding > 0) {
        //Click the default passe color
        if (default_color_selected == false) {
          clickByClass($('.passe-default-color'));
        }
        //Check if we have the right variant available for passe-partout
        variantCheck(
          findByKeyValue,
          calculated_passe_width,
          calculated_passe_height,
          'passe-input',
          option.type,
          passe_default_price
        );
      } else {
        //Do these if customer selects passe with 0cm
        sku_input_passe.value = '';
        $('.passe-input').remove();
        $('#passe-color-input').remove();
        no_passe_variants = false;
        passe_price = passe_default_price;
      }

      //Check if whole picture width/height is different than calculated width/height, if they are we have to replace glass and frame variants with new variants
      if (
        picture_width !== calculated_passe_width &&
        picture_height !== calculated_passe_height
      ) {
        replace_inputs = true;
      }

      //Find new frame variant if we have frame variant checked
      if (replace_inputs === true) {
        product_data = frame_product_data;
        picture_width = calculated_passe_width;
        picture_height = calculated_passe_height;

        //Check if we have the right variant available for frame
        variantCheck(
          findByKeyValue,
          picture_width,
          picture_height,
          'frame-input',
          'frame',
          frame_default_price
        );
      }

      //FInd new glass variant if we have glass variant selected allready
      if (
        ($('.glass-input')[0] && replace_inputs === true) ||
        (glass_deleted === true && replace_inputs === true)
      ) {
        product_data = glass_product_data;
        picture_width = calculated_passe_width;
        picture_height = calculated_passe_height;

        //Check if we have the right variant available for glass
        variantCheck(
          findByKeyValue,
          picture_width,
          picture_height,
          'glass-input',
          'glass',
          glass_default_price
        );
      }
    }
    //Glass selection clicked
    else if (option.type == 'glass') {
      $('.single-option[data-type="no-passe"]').removeClass('selected');

      //Glass selected and default price
      glass_product_data = product_data;

      // Get correct glass code to the custom SKU
      if (glass_product_data.handle == 'anti-reflex') {
        sku_glass = 'X';
      } else {
        sku_glass = 'N';
      };
      no_glass_selected = false;
      glass_default_price = option.price;

      if (option.width !== picture_width && option.height !== picture_height) {
        //Check if we have the right variant available for glass
        variantCheck(
          findByKeyValue,
          picture_width,
          picture_height,
          'glass-input',
          option.type,
          glass_default_price
        );
      } else {
        //Check if we have the right variant available for glass
        const option_width = roundUpTo(option.width, 10);
        const option_height = roundUpTo(option.height, 10);
        variantCheck(
          findByKeyValue,
          option_width,
          option_height,
          'glass-input',
          option.type,
          glass_default_price
        );
      }
    }

    $option.addClass('selected');
    populateDetailsDrawer(option);

    //Price calculation from cents to euros
    frame_total_price = frame_price / 100;
    passe_total_price = passe_price / 100;
    glass_total_price = glass_price / 100;
    picture_total_price = product_price / 100;
    framing_total_price = framing_cost_price / 100;

    //Change item prices on seperated view
    $('.frame-price').text(`€${frame_total_price.toFixed(2)}`);
    $('.passe-price').text(`€${passe_total_price.toFixed(2)}`);
    $('.glass-price').text(`€${glass_total_price.toFixed(2)}`);

    //Calculate total price
    configurator_total_price =
      picture_total_price +
      frame_total_price +
      passe_total_price +
      glass_total_price +
      framing_total_price;
    //Calculate price to fixed with 2 decimals
    configurator_total_price_fixed = configurator_total_price.toFixed(2);
    //Change the price debending on the total price
    $('span.price').text(`€${configurator_total_price_fixed}`);

    //Disable add to cart button if no variants are available
    if (
      no_frame_variants === true ||
      no_passe_variants === true ||
      no_glass_variants === true
    ) {
      hideElement($('.btn-available'));
      showElementFlex($('.btn-disabled__container'));
    } else {
      showElementFlex($('.btn-available'));
      hideElement($('.btn-disabled__container'));
    }

    //Show different texts depending on what variant isn't available or selected
    if (no_passe_selected === true) {
      changeText(disabled_add_to_cart, no_passe_selected_translation);
      sku_input_passe.value = '';
    } else if (no_glass_selected === true) {
      changeText(disabled_add_to_cart, no_glass_selected_translation);
    } else {
      if (no_frame_variants === true) {
        changeText(disabled_add_to_cart, no_frames_available_translation);
      } else if (no_passe_variants === true) {
        changeText(disabled_add_to_cart, no_passe_available_translation);
      } else if (no_glass_variants === true) {
        changeText(disabled_add_to_cart, no_glass_available_translation);
      }
    }

    //Calculate picture width and height with passe-partout and frame width
    pictureTotalWidth = +picture_actual_width + +frameWidth * 2 - 1;
    pictureTotalHeight = +picture_actual_height + +frameWidth * 2 - 1;

    let skuHeight;
    if (picture_actual_height.toString().includes('.')) {
      skuHeight = picture_actual_height.toString().replace('.', '');
    } else {
      skuHeight = picture_actual_height.toString() + '0';
    }

    if (parseFloat(picture_actual_height) < 100) {
      skuHeight = '0' + skuHeight;
    }

    let skuWidth;
    if (picture_actual_width.toString().includes('.')) {
      skuWidth = picture_actual_width.toString().replace('.', '');
    } else {
      skuWidth = picture_actual_width.toString() + '0';
    }

    if (parseFloat(picture_actual_width) < 100) {
      skuWidth = '0' + skuWidth;
    }

    let fullSKU = 'YD' + sku_frame + skuWidth + skuHeight + sku_frame_colour + sku_glass + '10';

    const currentURL = window.location.href
    if (currentURL.includes("cf-product")) {
      sku_input_frame.value = fullSKU;
      sku_full = fullSKU;
    } else {

    };

    // Add and delete line item for the actual sizes of the picture and frames
    addLineItem(
      'picture-dimensions',
      actual_size_translation,
      `${pictureTotalWidth}cm X ${pictureTotalHeight}cm`,
      add_to_cart_form
    );

    //Add line items for frame inside width and height if we are using only frames
    if (
      typeof $('#frame-width').val() !== 'undefined' ||
      typeof $('#frame-width').val() !== 'undefined'
    ) {
      const inside_frames_dimensions = `${$('#frame-width').val()}cm X ${$(
        '#frame-height'
      ).val()}cm`;
      addLineItem(
        'inside-frames-dimension',
        dimensions_inside_translation,
        inside_frames_dimensions,
        add_to_cart_form
      );
    }
  });
}

//Variables for drawers
const left_drawer = $('[data-type="background-customizer"]');
const right_drawer = $('[data-type="details-window"]');

//This function handles showing / hiding the background drawer.
function toggle_background_customizer() {
  left_drawer.toggleClass('open-left');
  left_drawer.toggleClass('close-left');
  $('.blur-background').toggleClass('bg-hidden');
  $('body').toggleClass('block-body');
}

//This function handles showing / hiding the details drawer.
function toggle_details_drawer() {
  right_drawer.toggleClass('open-right');
  right_drawer.toggleClass('close-right');
  $('.blur-background').toggleClass('bg-hidden');
  $('body').toggleClass('block-body');
}

//This function handles populating of data to details drawer
function populateDetailsDrawer() {
  var drawer = $('[data-type="details-window"]');
  drawer.find('.frame-title').text(selected_frame_name);
  drawer.find('.frame-material').text(frame_material);
  drawer.find('.frame-t-width').text(frame_actual_width + ' cm');
  drawer.find('.frame-t-height').text(frame_actual_height + ' cm');
  drawer.find('.frame-p-width').text(frame_profile_width) + 'mm';
  drawer.find('.frame-p-height').text(frame_profile_height) + 'mm';
}

// This function initializes the color options for page load and should generate
// some kind of template later loaded with open function.
function initBackgroundCustomizer() {
  const input = document.getElementById('background-input');
  const left_container = document.querySelector('.configurator-left');
  if (!input) return;

  input.addEventListener('input', (evt) => {
    const evt_value = evt.target.value;
    left_container.style.backgroundColor = evt_value;
  });
}

function tool_btn_clicked() {
  var $button = $(this);
  var tool_type = $button.data('tool');
  if (tool_type == 'background-customizer') {
    toggle_background_customizer();
  } else {
    toggle_details_drawer();
  }
}

function initConfigurator() {
  $('.single-option').click(option_clicked);
  $('.tool-button, .show-details').click(tool_btn_clicked);
  $('.close-drawer').click(function () {
    right_drawer.removeClass('open-right');
    right_drawer.addClass('close-right');
    left_drawer.removeClass('open-left');
    left_drawer.addClass('close-left');
    $('.blur-background').toggleClass('bg-hidden');
    $('body').toggleClass('block-body');
  });

  // Init background customizer
  initBackgroundCustomizer();
}

//Fucntion to close drawers
function closeDrawers() {
  right_drawer.removeClass('open-right');
  right_drawer.addClass('close-right');
  left_drawer.removeClass('open-left');
  left_drawer.addClass('close-left');
  $('.blur-background').addClass('bg-hidden');
  $('body').toggleClass('block-body');
}

//Function for changing the width from input fields
function frameWidthChanged() {
  const selected_frame = $('.frame-btns.selected');
  const selected_passe = $('.passe-btns.selected');
  const selected_glass = $('.glass-btns.selected');
  const min_value = document.getElementById('frame-width').min;
  const max_value = document.getElementById('frame-width').max;

  //Check that inserted value matches min and max values
  const changed_width_val = $('#frame-width').val();
  const checked_value = minmax(changed_width_val, +min_value, +max_value);
  $('#frame-width').val(checked_value);

  //Animate picture dimensions change
  changePictureDimensions();

  //Set changed value to data
  $('.single-option')
    .data('width', checked_value)
    .attr('data-width', checked_value);
  //"Fake click" selected options
  clickByClass(selected_frame);
  clickByClass(selected_passe);
  clickByClass(selected_glass);
}

//Function for changing the height from input fields
function frameHeightChanged() {
  const selected_frame = $('.frame-btns.selected');
  const selected_passe = $('.passe-btns.selected');
  const selected_glass = $('.glass-btns.selected');
  const min_value = document.getElementById('frame-height').min;
  const max_value = document.getElementById('frame-height').max;

  //Check that inserted value matches min and max values
  const changed_height_val = $('#frame-height').val();
  const checked_value = minmax(changed_height_val, +min_value, +max_value);
  $('#frame-height').val(checked_value);

  //Animate picture dimensions change
  changePictureDimensions();

  //Set changed value to data
  $('.single-option')
    .data('height', checked_value)
    .attr('data-height', checked_value);
  //"Fake click" selected options
  clickByClass(selected_frame);
  clickByClass(selected_passe);
  clickByClass(selected_glass);
}

//Change displayed frame picture
function changePictureDimensions() {
  const changed_width_val = $('#frame-width').val();
  const changed_width = parseInt(changed_width_val);
  const changed_height_val = $('#frame-height').val();
  const changed_height = parseInt(changed_height_val);

  if (changed_width > changed_height) {
    let cm_to_pixel = 420 / changed_width;
    let frame_picture_width = changed_width * cm_to_pixel;
    let frame_picture_height = changed_height * cm_to_pixel;

    //First we change the dimensions of the frame picture
    $('.configurator-image').animate(
      {
        width: frame_picture_width + 'px',
        height: frame_picture_height + 'px',
      },
      400
    );

    //The we want to change the cm divider what we calculate in the liquid side when we load the page
    $('.single-option.frame-color')
      .data('cm-divider', changed_width)
      .attr('data-cm-divider', changed_width);
    $('.single-option.passe-btns')
      .data('cm-divider', changed_width)
      .attr('data-cm-divider', changed_width);
  } else {
    let cm_to_pixel = 420 / changed_height;
    let frame_picture_width = changed_width * cm_to_pixel;
    let frame_picture_height = changed_height * cm_to_pixel;

    //First we change the dimensions of the frame picture
    $('.configurator-image').animate(
      {
        width: frame_picture_width + 'px',
        height: frame_picture_height + 'px',
      },
      400
    );

    //The we want to change the cm divider what we calculate in the liquid side when we load the page
    $('.single-option.frame-color')
      .data('cm-divider', changed_height)
      .attr('data-cm-divider', changed_height);
    $('.single-option.passe-btns')
      .data('cm-divider', changed_height)
      .attr('data-cm-divider', changed_height);
  }

  //Hide loading screen
  setTimeout(function () {
    $('.framing--load').removeClass('framing--load-shown');
    $('.framing--load').addClass('framing--load-hidden');
  }, 1000);
}

//Add to cart send form
$('.btn-available').click(function () {
  $('#configurator-form').submit();
});

//Check window width and assign image width for dimension calculation
$(document).ready(function () {
  initConfigurator();

  //Shown/hide prices btn
  $('.expand-btn--js').click(function () {
    $('.seperated-prices--js').toggle({
      duration: 150,
    });
    $('.open-arrow').toggleClass('open-arrow--closed');
  });

  const base_image_width = $('.configurator-image').width();
  const base_image_height = $('.configurator-image').height();
  if (base_image_width > base_image_height) {
    convert_to_pixels = base_image_width;
  } else {
    convert_to_pixels = base_image_height;
  }

  //Close drawers when clicked to blurred area
  $('.blur-background').click(function () {
    closeDrawers();
  });

  const currentURL = window.location.href
  const searchParams = new URLSearchParams(window.location.search);
  // Inputs for width and height
  const widthInput = document.getElementById('frame-width');
  const heightInput = document.getElementById('frame-height');
  if (currentURL.includes("cf-product")) {
    if (searchParams.has('frame-type')) {

    } else {
      //Click the first frame
      $('.first-frame').trigger('click');
    };
  } else {
    //Click the first frame
    $('.first-frame').trigger('click');
  }

  //Check if we are configuring frames with out picture
  if ($('#use-frames-logic').length) {
    let widthInputChanged = debounce(function () {
      frameWidthChanged();
    }, 1000);

    let heightInputChanged = debounce(function () {
      frameHeightChanged();
    }, 1000);

    //Scroll to top when input is focused
    $('#frame-width, #frame-height').focus(function () {
      $(document).scrollTop(500);
    });

    $('#frame-width').on('input', function () {
      $('.framing--load').addClass('framing--load-shown');
      $('.framing--load').removeClass('framing--load-hidden');
      widthInputChanged();
    });

    $('#frame-height').on('input', function () {
      $('.framing--load').addClass('framing--load-shown');
      $('.framing--load').removeClass('framing--load-hidden');
      heightInputChanged();
    });
  };
});

//Do the same calculation when window is resized
$(window).resize(function () {
  const base_image_width = $('.configurator-image').width();
  const base_image_height = $('.configurator-image').height();
  if (base_image_width > base_image_height) {
    convert_to_pixels = base_image_width;
  } else {
    convert_to_pixels = base_image_height;
  }
});